import styled, { css, keyframes } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getFont, getLineHeight } from '@finect/tabular-utils/getFont';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { getImageUrl } from '../../../Image';
var actionPop = function actionPop(_ref) {
  var maxScale = _ref.maxScale;
  return keyframes(["0%{opacity:0;transform:scale(0);}30%{opacity:1;transform:scale(0.8);}50%{transform:scale(", ");}"], maxScale || 1.15);
};
var animationPop = css(["animation:", " 0.3s ease-in;"], actionPop);
var showPop = function showPop() {
  return keyframes(["0%{opacity:0;transform:scale(0.9);}50%{transform:scale(1);}"]);
};
var animationShow = css(["animation:", " 0.3s ease-in;"], showPop);
var blockStyles = function blockStyles() {
  var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return css(["", ";"], first ? 'padding-top: 12px' : '');
};
var verticalSpacingStyles = function verticalSpacingStyles() {
  var topMargin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return css(["", ";"], topMargin ? 'margin-top: 12px' : '');
};
var bottomPosition = function bottomPosition(bottom) {
  return bottom ? css(["margin-top:auto;"]) : '';
};
export var Header = styled.div.withConfig({
  displayName: "Blocks__Header",
  componentId: "sc-k639v2-0"
})(["padding:5px 16px 0;", ";"], function (props) {
  return blockStyles(props.first);
});
export var ProductName = styled(AppLink).withConfig({
  displayName: "Blocks__ProductName",
  componentId: "sc-k639v2-1"
})(["display:flex;align-items:", ";overflow:hidden;min-height:", ";max-height:", ";margin-top:", ";margin-bottom:4px;cursor:pointer;font-weight:500;white-space:normal;", ";color:", ";"], function (_ref2) {
  var $verticalAlign = _ref2.$verticalAlign;
  return $verticalAlign ? $verticalAlign : 'center';
}, function (_ref3) {
  var height = _ref3.height;
  return "".concat(height || 3 * getLineHeight(1, 'xcompact'), "rem");
}, function (_ref4) {
  var height = _ref4.height;
  return "".concat(height || 3 * getLineHeight(1, 'xcompact'), "rem");
}, function (_ref5) {
  var _ref5$$topMargin = _ref5.$topMargin,
    $topMargin = _ref5$$topMargin === void 0 ? false : _ref5$$topMargin;
  return "".concat($topMargin ? 36 + 6 : 6, "px");
}, getFont(1, 'xcompact'), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.font;
});
export var SocialStatsBlock = styled.div.withConfig({
  displayName: "Blocks__SocialStatsBlock",
  componentId: "sc-k639v2-2"
})(["display:", ";", " padding:5px 16px;> div{margin-right:8px;}a{display:", ";}a + a{margin-left:8px;margin-left:", ";}svg{width:16px;height:16px;vertical-align:unset;}"], function (_ref7) {
  var _ref7$display = _ref7.display,
    display = _ref7$display === void 0 ? 'flex' : _ref7$display;
  return display;
}, function (_ref8) {
  var display = _ref8.display;
  return display === 'flex' ? 'align-items: center;' : '';
}, function (_ref9) {
  var _ref9$display = _ref9.display,
    display = _ref9$display === void 0 ? 'flex' : _ref9$display;
  return display;
}, function (_ref10) {
  var _ref10$display = _ref10.display,
    display = _ref10$display === void 0 ? 'flex' : _ref10$display;
  return display === 'flex' ? '8px' : '0';
});
export var SocialStatsCount = styled(AppLink).withConfig({
  displayName: "Blocks__SocialStatsCount",
  componentId: "sc-k639v2-3"
})(["cursor:pointer;", ";font-weight:500;"], getFont(-1, 'compact'));
export var SocialStatsCountSpacingReserve = styled.div.withConfig({
  displayName: "Blocks__SocialStatsCountSpacingReserve",
  componentId: "sc-k639v2-4"
})(["min-height:18px;"]);
export var LabelsBlock = styled.div.withConfig({
  displayName: "Blocks__LabelsBlock",
  componentId: "sc-k639v2-5"
})(["display:flex;padding:5px 16px;font-size:90%;", ";span{margin-right:4px;}"], function (props) {
  return blockStyles(props.first);
});
export var OrganizationsBlock = styled.div.withConfig({
  displayName: "Blocks__OrganizationsBlock",
  componentId: "sc-k639v2-6"
})(["", " display:flex;min-height:34px;padding:0 16px;margin-bottom:8px;span{margin-right:4px;}img{border:1px solid #2a2a2a10;}"], function (_ref11) {
  var bottom = _ref11.bottom;
  return bottomPosition(bottom);
});
export var Divider = styled.div.withConfig({
  displayName: "Blocks__Divider",
  componentId: "sc-k639v2-7"
})(["", " width:100%;height:1px;background-color:", ";background-color:", ";"], function (_ref12) {
  var bottom = _ref12.bottom;
  return bottomPosition(bottom);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.terciaryL;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.ui;
});
export var DescriptionBlock = styled.div.withConfig({
  displayName: "Blocks__DescriptionBlock",
  componentId: "sc-k639v2-8"
})(["", " display:block;padding:5px 16px;margin-bottom:8px;p{overflow-y:hidden;height:", ";max-height:", ";", ";color:", ";}"], function (_ref15) {
  var bottom = _ref15.bottom;
  return bottomPosition(bottom);
}, "".concat(4 * getLineHeight(-2, 'compact'), "rem"), "".concat(4 * getLineHeight(-2, 'compact'), "rem"), getFont('-2', 'compact'), function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.uiDD;
});
export var PromoBlock = styled.div.withConfig({
  displayName: "Blocks__PromoBlock",
  componentId: "sc-k639v2-9"
})(["", " ", ";display:block;padding:5px 16px;svg{display:inline-block;vertical-align:text-bottom;}span{display:block;position:relative;top:-18px;overflow:hidden;height:", ";max-height:48px;margin-left:24px;font-weight:400;color:", ";", ";}"], function (_ref17) {
  var bottom = _ref17.bottom;
  return bottomPosition(bottom);
}, function (props) {
  return blockStyles(props.first);
}, "".concat(3 * getLineHeight(-2, 'compact'), "rem"), function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.uiDD;
}, getFont(-2, 'compact'));
export var HighlightsBlock = styled.div.withConfig({
  displayName: "Blocks__HighlightsBlock",
  componentId: "sc-k639v2-10"
})(["display:block;padding:5px 16px;margin-bottom:8px;div{overflow:hidden;white-space:nowrap;word-break:break-all;text-overflow:ellipsis;span{position:relative;font-size:11px;font-weight:500;line-height:16px;", ";}> span + span{margin-left:4px;&:before{display:inline;margin-right:4px;content:'|';color:", ";}}}"], getFont('-2', 'compact'), function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.fontLL;
});
export var FeatureSetBlock = styled.div.withConfig({
  displayName: "Blocks__FeatureSetBlock",
  componentId: "sc-k639v2-11"
})(["", " ", ";display:block;padding:5px 16px;svg{width:16px;height:16px;vertical-align:unset;}"], function (_ref20) {
  var bottom = _ref20.bottom;
  return bottomPosition(bottom);
}, function (props) {
  return verticalSpacingStyles(props.topMargin);
});
export var BuyBlock = styled.div.withConfig({
  displayName: "Blocks__BuyBlock",
  componentId: "sc-k639v2-12"
})(["", " ", ";display:block;padding:5px 16px;svg{margin-right:9px;vertical-align:text-bottom;}"], function (_ref21) {
  var bottom = _ref21.bottom;
  return bottomPosition(bottom);
}, function (_ref22) {
  var isCompact = _ref22.isCompact;
  return isCompact ? 'margin-top: 30px;' : '';
});
export var MoreInfoBlock = styled.div.withConfig({
  displayName: "Blocks__MoreInfoBlock",
  componentId: "sc-k639v2-13"
})(["", " display:block;padding:5px 16px 0;font-weight:400;text-align:center;"], function (_ref23) {
  var bottom = _ref23.bottom;
  return bottomPosition(bottom);
});
export var FeatureLabel = styled.div.withConfig({
  displayName: "Blocks__FeatureLabel",
  componentId: "sc-k639v2-14"
})(["font-size:11px;", " ", " ", " ", ";div{display:inline-block;font-weight:500;", ";color:", ";}"], function (_ref24) {
  var bold = _ref24.bold;
  return bold ? 'font-weight: 600;' : '';
}, function (_ref25) {
  var medium = _ref25.medium;
  return medium ? getFont('-1') : '';
}, function (_ref26) {
  var large = _ref26.large;
  return large ? getFont('1') : '';
}, textEllipsis, getFont('-1'), function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.fontL;
});
export var Cover = styled.div.withConfig({
  displayName: "Blocks__Cover",
  componentId: "sc-k639v2-15"
})(["display:block;width:100%;min-height:163px;max-height:163px;background-image:", ";background-position:top;background-size:cover;", ";"], function (_ref28) {
  var image = _ref28.image;
  return "url(".concat(getImageUrl(image, {
    height: 163
  }), ")");
}, function (_ref29) {
  var image = _ref29.image;
  return !image && css(["display:flex;align-items:center;justify-content:center;background-color:", ";svg{width:80px;height:80px;path{fill:", ";}}"], function (_ref30) {
    var theme = _ref30.theme;
    return theme.colors.ui;
  }, function (_ref31) {
    var theme = _ref31.theme;
    return theme.colors.terciaryLL;
  });
});
export { actionPop, animationPop, showPop, animationShow };